/**
 * Pagination class for handling pagination data.
 */
export class Pagination {
  [key: string]: unknown;

  current: number = 1;

  first: number = 1;

  last: number = 1;

  numItemsPerPage: number = 1;

  pageCount: number = 1; // Amount of pages.

  totalCount: number = 1; // Amount of list items.

  pageRange: number = 1; // Provided by BE not in use.

  startPage: number = 1; // Provided by BE not in use.

  endPage: number = 1; // Provided by BE not in use.

  pagesInRange: number[] = []; // Provided by BE not in use.

  firstPageInRange: number = 1; // Provided by BE not in use.

  lastPageInRange: number = 1; // Provided by BE not in use.

  currentItemCount: number = 1; // Provided by BE not in use.

  firstItemNumber: number = 1; // Provided by BE not in use.

  lastItemNumber: number = 1; // Provided by BE not in use.

  /**
   * Constructor.
   */
  constructor(pagination?: Partial<Pagination>) {
    this.update(pagination);
  }

  /**
   * Trigger this to update the pagination data.
   */
  update(pagination?: Partial<Pagination>) {
    if (pagination) {
      Object.keys(pagination).forEach((key: string) => {
        if (key in this && typeof pagination[key] === 'number') {
          this[key] = pagination[key];
        }
      });
    }
  }

  /**
   * Checks if it has more than one page.
   */
  moreThanOnePage(): boolean {
    return this.pageCount > 1;
  }
}
